module.exports = __webpack_public_path__ + "img/viessmann-heating-system-lg.c26b4984.svg";